export enum WorkflowContextualMenuActions {
    Edit = 0,
    Delete = 1,
    MarkAsMain = 2,
}
